import { useState, useCallback } from "react";
import { ProductService } from "../../../services/ProductService.js";

const productService = new ProductService();

const useRemarcadores = (urlMedidores) => {
  const [tiposRemarcador, setTiposRemarcador] = useState([]);
  const [proveedoresRemarcador, setProveedoresRemarcador] = useState([]);
  const [loadingTiposRemarcador, setLoadingTiposRemarcador] = useState(false);
  const [loadingProveedoresRemarcador, setLoadingProveedoresRemarcador] = useState(false);

  const fetchTiposRemarcador = useCallback(async () => {
    try {
      setLoadingTiposRemarcador(true);
      const tipos = await productService.buscarTiposRemarcador(urlMedidores);
      setTiposRemarcador(tipos);
    } catch (error) {
      console.error("Error al obtener tipos de remarcador:", error);
      setTiposRemarcador([]);
    } finally {
      setLoadingTiposRemarcador(false);
    }
  }, [urlMedidores]);

  const fetchProveedoresRemarcador = useCallback(async () => {
    try {
      setLoadingProveedoresRemarcador(true);
      const proveedores = await productService.buscarProveedores(urlMedidores);
      setProveedoresRemarcador(proveedores);
    } catch (error) {
      console.error("Error al obtener proveedores:", error);
      setProveedoresRemarcador([]);
    } finally {
      setLoadingProveedoresRemarcador(false);
    }
  }, [urlMedidores]);

  return {
    tiposRemarcador,
    proveedoresRemarcador,
    loadingTiposRemarcador,
    loadingProveedoresRemarcador,
    fetchTiposRemarcador,
    fetchProveedoresRemarcador,
  };
};

export default useRemarcadores;
